export default "__VITE_ASSET__C9565MQz__"